<template>
  <div id="login">
    <Navbar></Navbar>
    <div class="container">
      <div class="login-form">
        <h1 class="mb-4">Login</h1>
        <form v-if="showLoginForm" @submit.prevent>
          <div class="form-group">
            <input class="form-control" v-model.trim="loginForm.email" type="text" placeholder="you@email.com" id="email1" />
          </div><!-- /.form-group -->
          <div class="form-group">
            <input class="form-control" v-model.trim="loginForm.password" type="password" placeholder="******" id="password1" />
          </div><!-- /.form-group -->
          <button class="btn btn-primary" @click="login">Log In</button>
          <div class="extras mt-2">
            <button class="btn btn-sm btn-default" @click="toggleForm">Create an Account</button>
            <button class="btn btn-sm btn-default mt-1" @click="togglePasswordReset">Forgot Password</button>
          </div><!-- /.extras -->
        </form>
        <form v-if="!showLoginForm && !showForgotPassword" @submit.prevent>
          <h2>Create Account</h2>
          <div class="form-group">
            <label for="name">Your Name</label>
            <input class="form-control" v-model="signupForm.name" type="text" placeholder="Arthur Weasley" id="name" />
          </div><!-- /.form-group -->
          <div class="form-group">
            <label for="email2">Email</label>
            <input class="form-control" v-model.trim="signupForm.email" type="text" placeholder="you@email.com" id="email2" />
          </div><!-- /.form-group -->
          <div class="form-group">
            <label for="password2">Password</label>
            <input class="form-control" v-model.trim="signupForm.password" type="password" placeholder="min 6 characters" id="password2" />
          </div><!-- /.form-group -->
          <button class="btn btn-primary" @click="signup">Sign Up</button>
          <div class="extras mt-2">
              <button class="btn btn-sm btn-default" @click="toggleForm">Back to Log In</button>
          </div><!-- /.extras -->
        </form>
        <form v-if="showForgotPassword" @submit.prevent class="password-reset">
          <div v-if="!passwordResetSuccess">
            <h2>Reset Password</h2>
            <p>We will send you an email to reset your password</p>
            <div class="form-group">
              <label for="email3">Email</label>
              <input class="form-control" v-model.trim="passwordForm.email" type="text" placeholder="you@email.com" id="email3" />
            </div><!-- /.form-group -->
            <button class="btn btn-primary" @click="resetPassword">Submit</button>
            <div class="extras mt-2">
              <button class="btn btn-sm btn-default" @click="togglePasswordReset">Back to Log In</button>
            </div><!-- /.extras -->
            </div>
            <div v-else>
              <h1>Email Sent</h1>
              <p>check your email for a link to reset your password</p>
              <button class="btn btn-primary" @click="togglePasswordReset">Back to login</button>
            </div>
        </form>
        <transition name="fade">
          <div v-if="errorMsg !== ''" class="error-msg">
            <p>{{ errorMsg }}</p>
          </div><!-- /.error-msg -->
        </transition>
      </div><!-- /.login-form -->
    </div><!-- /.container -->
  </div><!-- /#login -->
</template>

<script>
  const fb = require('../firebaseConfig.js')
  import Navbar from './Navbar.vue'

  export default {
    data() {
      return {
        loginForm: {
          email: '',
          password: ''
        },
        signupForm: {
          name: '',
          email: '',
          password: ''
        },
        passwordForm: {
          email: ''
        },
        showLoginForm: true,
        showForgotPassword: false,
        passwordResetSuccess: false,
        performingRequest: false,
        errorMsg: ''
      }
    },
    components: { Navbar },
    methods: {
      toggleForm() {
        this.errorMsg = ''
        this.showLoginForm = !this.showLoginForm
      },
      togglePasswordReset() {
        if (this.showForgotPassword) {
          this.showLoginForm = true
          this.showForgotPassword = false
          this.passwordResetSuccess = false
        } else {
          this.showLoginForm = false
          this.showForgotPassword = true
        }
      },
      login() {
        this.performingRequest = true
        fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
          this.$store.commit('setCurrentUser', user.user)
          this.$store.dispatch('fetchUserProfile')
          this.performingRequest = false
          this.$router.push({name: 'Dashboard'})
        }).catch(err => {
          console.log(err)
          this.performingRequest = false
          this.errorMsg = err.message
        })
      },
      signup() {
        this.performingRequest = true
        fb.auth.createUserWithEmailAndPassword(this.signupForm.email, this.signupForm.password).then(user => {
          console.log(user.user)
          this.$store.commit('setCurrentUser', user.user)
          // create user obj
          fb.usersCollection.doc(user.user.uid).set({
            name: this.signupForm.name
          }).then(() => {
            this.$store.dispatch('fetchUserProfile')
            this.performingRequest = false
            this.$router.push({name: 'Dashboard'})
          }).catch(err => {
            console.log(err)
            this.performingRequest = false
            this.errorMsg = err.message
          })
        }).catch(err => {
          console.log(err)
          this.performingRequest = false
          this.errorMsg = err.message
        })
      },
      resetPassword() {
        this.performingRequest = true
        fb.auth.sendPasswordResetEmail(this.passwordForm.email).then(() => {
          this.performingRequest = false
          this.passwordResetSuccess = true
          this.passwordForm.email = ''
        }).catch(err => {
          console.log(err)
          this.performingRequest = false
          this.errorMsg = err.message
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Login.vue